module.exports = __webpack_public_path__ + "static/media/insider.2d2e2dca.svg";